import Icon from 'veui/components/Icon'

Icon.register({
  'chevron-double-right': {
    paths: [
      {
        d: 'M22.59 2.59a2 2 0 000 2.82L41.17 24 22.6 42.59a2 2 0 002.82 2.82l20-20a2 2 0 000-2.82l-20-20a2 2 0 00-2.82 0zm-19 0a2 2 0 000 2.82L22.17 24 3.6 42.59a2 2 0 002.8 2.81l20-20a2 2 0 000-2.82l-20-20a2 2 0 00-2.82 0z'
      }
    ],
    width: '48',
    height: '48'
  }
})
